export default "__VITE_ASSET__rZHfw0sv__"